import { AnalyticsAction, AnalyticsActionSubject } from '../types';

import { BaseInvitePeopleAnalytics, type FailedFetchAttributes } from '../analytics';

export class ExperimentsAnalytics extends BaseInvitePeopleAnalytics {
	teamsFieldToggled(opened: boolean): void {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.TEAM_INVITES,
			action: AnalyticsAction.CHANGED,
			attributes: {
				opened,
			},
		});
	}

	teamsFieldUsersInvited(attributes: {
		inviteeCount: number;
		isNewTeam: boolean;
		successInviteeCount: number;
		status: 'SUCCESS' | 'PARTIAL_SUCCESS' | 'ERROR';
	}): void {
		this.fireTrack({
			actionSubject: AnalyticsActionSubject.TEAM_INVITES,
			action: AnalyticsAction.INVITED,
			attributes,
		});
	}

	fetchOrgSettingsFailed(
		attributes: {
			orgId: string;
		} & FailedFetchAttributes,
	): void {
		this.fireOperational({
			actionSubject: AnalyticsActionSubject.FETCH_ORG_SETTINGS,
			action: AnalyticsAction.FAILED,
			attributes,
		});
	}
}
